import { FC } from 'react';
import { useWalletTracking } from '../hooks/useWalletTracking';

/**
 * Component to track wallet connections for analytics
 * This component doesn't render anything, it just tracks wallet connections
 */
export const WalletTracker: FC = () => {
  useWalletTracking();
  return null;
};

